import React from 'react';
import { useChain, useWallet } from '../../../hooks/useEventStates';
import Slider from 'react-slick';
import slide5 from '../../../assets/images/drew.png'
import video from '../../../assets/images/video.mp4'
import video1 from '../../../assets/images/video1.mp4'
import video2 from '../../../assets/images/video2.mp4'
import video3 from '../../../assets/images/video3.mp4'
import {
  FaYoutube,
  FaTwitter,
  FaInstagram,
  FaTiktok,
  FaTwitch,
} from 'react-icons/fa';
import owners from '../../../assets/images/poker.gif';
import DeskSliderContent from '../Home/DeskSliderContent.jsx';
import MobileSliderContent from '../Home/MobileSliderContent.jsx';


const Main = () => {
  const account = useWallet();
  const chainId = useChain();

  // const sliderSettings = {
  //   dots: true,
  //   arrows: false,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   autoplaySpeed: 5000,
  //   infinite: true,
  // };

  const sliderSettings = {
    dots: true,
    arrows: true,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const mobileSliderSettings = {
    dots: true,
    arrows: false,
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
   <></>
  );
};

export default Main;
